import React from "react"

export const getColor = (percentage) => {
  if (percentage === 0) {
    return {
      pathColor: 'rgb(128,128,128)',
      trailColor: 'rgba(128,128,128,0.3)',
    }
  }
  if (percentage > 75)
    return {
      pathColor: 'rgb(50,205,50)',
      trailColor: 'rgba(50,205,50,0.3)',
    }
  if (percentage > 25)
    return {
      pathColor: 'rgb(255,215,0)',
      trailColor: 'rgba(255,215,0,0.3)',
    }
  return {
    pathColor: 'rgb(255,0,0)',
    trailColor: 'rgba(255,0,0,0.3)',
  }
}


export const ProgressProvider = ({ valueStart, valueEnd, children }) => {
  const [value, setValue] = React.useState(valueStart)
  React.useEffect(() => {
    setValue(valueEnd)
  }, [valueEnd])

  return children(value)
}